import React from "react"
import { Redirect } from "react-router-dom"
import { Progress } from "@carrotfertility/carotene-core"
import { useFlags } from "launchdarkly-react-client-sdk"
import { useIsSprintsVisible } from "#/services/user/hooks/useSprintsQuery"
import { DbgPaths } from "#/utils/Paths"
import SprintIntroPage from "./page"
import { SprintsUnauthorizedPage } from "./SprintsUnauthorizedPage"

export function SprintsLandingPageRoute(): JSX.Element {
  const { sprintsJourneyExpansion } = useFlags()
  const { isVisible: shouldShowSprintsPage, isLoading } = useIsSprintsVisible()

  if (isLoading) {
    return <Progress />
  }

  if (!shouldShowSprintsPage) {
    return sprintsJourneyExpansion ? <SprintsUnauthorizedPage /> : <Redirect to={DbgPaths.METABOLIC_FERTILITY_HEALTH} />
  }

  return <SprintIntroPage />
}
